import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import {
  Grid,
  Typography,
  Paper,
  Box
} from "@mui/material";
import { withStyles } from "@mui/styles";
import { ReactComponent as SmLogo } from "../Common/Logo/smLogo.svg";
import { ReactComponent as Mountains } from "../Auth/Icons/mountains.svg";
const styles = (theme) => ({
  root: {
    flexGrow: 1,
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    //marginTop: theme.spacing(1)
  },
  formhold: {
    marginLeft: theme.spacing(4),
    marginRight: 27,
    marginTop: theme.spacing(4),
    marginBottom: 20,
    [theme.breakpoints.down("xs")]: {
      margin: theme.spacing(2),
    },
  },
  grid: {
    minHeight: "100vh",
  },
  main: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    minWidth: 720,
    maxWidth: 720,
    [theme.breakpoints.down(740)]: {
      maxWidth: 600,
      minWidth: 600,
    },
    [theme.breakpoints.down("xs")]: {
      minHeight: "100vh",
      minWidth: 100,
    },
  },
  logingrid: {
    minHeight: 200,
  },
  logo: {
    width: "100%",
    marginBottom: theme.spacing(2),
    [theme.breakpoints.down("xs")]: {
      maxWidth:"80%",
      marginTop:"15px"
    },
    [theme.breakpoints.up("sm")]: {
      maxHeight: 160,
      maxWidth:"100%",
    }
  },
  logoContainer:{
    display: "flex",
    justifyContent: "center"
  },
  mountainsgrid: {
    backgroundColor: "#FDEFE7",
    //height: "100%"
    borderTopRightRadius: 8,
    borderBottomRightRadius: 8,
    overflow: "hidden",
    display: "flex",
  },
  mountains: {
    width: "105%",
    marginLeft: -1,
    alignSelf: "flex-end",
    marginBottom: -15,
    [theme.breakpoints.down("xs")]: {
      width: "160%",
      height: "160%",
      marginBottom: -20,
      alignSelf: "flex-start",
    },
  },
  title: {
    paddingBottom: 10,
    fontSize: 32,
    [theme.breakpoints.down("sm")]: {
      fontSize: 25,
    },

    [theme.breakpoints.down("xs")]: {},
  },
  subtitle: {
    color: "#5A6375",
    fontSize: 14,
    marginTop: 3,
    marginBottom: theme.spacing(2),
  }
});

class Maintenance extends Component {
  state = {
    show: false,
    transformTo: {},
  };
  

  render() {
    const {
      classes
    } = this.props;
    return (
      <div className={classes.root}>
        <Grid
          container
          spacing={0}
          direction="column"
          justify="center"
          alignItems="center"
          className={classes.grid}
        >
          <Grid className={classes.logoContainer}>
              <SmLogo className={classes.logo} />
          </Grid>
          <Grid item>
            <Paper className={classes.main}>
              <Grid
                container
                spacing={0}
                direction="row-reverse"
                justify="center"
                alignItems="stretch"
                className={classes.logingrid}
              >
                <Box sx={{ display: { xs: 'none', sm: 'flex' } }}>
                  <Grid item size={{xs:12, sm:5}} className={classes.mountainsgrid}>
                    <Mountains className={classes.mountains} />
                  </Grid>
                </Box>
                <Grid item size={{xs:12, sm:7}} className={classes.fieldholdergrid}>
                  <div className={classes.formhold}>
                    <Typography variant="h4" className={classes.title}>
                      Hang Tight! We're Making Things Better
                    </Typography>
                    <Typography variant="body1" className={classes.subtitle}>
                      We're taking a quick break for essential maintenance to enhance your experience.
                    </Typography>                       
                    <Typography variant="body1" className={classes.subtitle}>
                      We'll be back online soon with some exciting updates!
                    </Typography>
                  </div>
                </Grid>
              </Grid>
            </Paper>
          </Grid>
        </Grid>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return state;
}

function mapDispatchToProps(dispatch) {
  return {
    ...bindActionCreators(
      {},
      dispatch
    ),
    dispatch,
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(Maintenance));
